module.exports = __webpack_public_path__ + "images/178_160.jpg";